import { Col, Row } from 'antd';
import React from 'react';

export const RegistrationFormRow = ({
  children,
}: { children: React.ReactNode }) => {
  const childArray = React.Children.toArray(children);

  return (
    <Row>
      <Col span={11}>{childArray[0]}</Col>
      <Col span={2} />
      <Col span={11}>{childArray[1]}</Col>
    </Row>
  );
};
